import { render } from "./CreditsLine.vue?vue&type=template&id=915c66e8"
const script = {}

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__